import HttpClient from '@/common/lib/http-client'
import type { ISetting } from '@/common/models/data/common/settings'
import { type ISong, Song } from '@/common/models/data/dashboard/song'

import { stream as Api } from '@/app/api'

class PlayerRepository {
    async url (): Promise<string> {
        const response = await HttpClient.getJson<ISetting>(Api.url)

        return response.value
    }

    async currentSong (): Promise<Song> {
        const song = await HttpClient.getJson<ISong>(Api.stats)

        return new Song(song.artist, song.title)
    }
}

export default new PlayerRepository()
